export const ServiceDetailsFactory = () => {
    return function ServiceDetails() {
        this.lastInspection = null;
        this.nextInspection = null;
        this.frequency = null;
        this.installationDate = null;
        this.retirementDate = null;
    }
};
